import { MasterDialog } from "#common/Dialog/Dialog"
import { fillDefaults } from "#core/functions/dataHelpers"
import { InputAutocompleteAreasId } from "#core/inputs/autocomplete/InputAutocompleteAreasId"
import { InputAutocompleteJobProfileId } from "#core/inputs/autocomplete/InputAutocompleteJobProfileId"
import { useApiSend } from "#hooks/useApiSend"
import { jobProfilePut } from "#job-profile/services/api"
import { Checkbox, FormControlLabel, FormGroup, TextField } from "@mui/material"
import Grid2 from "@mui/material/Unstable_Grid2"
import { useCallback, useEffect, useMemo, useState } from "react"
import { toast } from "react-toastify"

const PROFILE_DEFAULT = {
	nombre: "",
	objetivo: "",
	contribuciones: "",
	education: "",
	years_of_experience: "",
	viajar: false,
	reporta_a_departamento: null,
	departamento: null,
	reporta_a: null,
}

export default function JobProfileForm({ value = {}, setValue, autoFetch = true }) {
	const register = (name) => {
		return {
			value: value[name] || "",
			onChange: (e) => setValue({ ...value, [name]: e.target.value }),
		}
	}

	const registerAutocompleted = (name) => {
		return {
			value: value[name] || null,
			setValue: (datum) => setValue({ ...value, [name]: datum }),
		}
	}

	return (
		<Grid2 container spacing={2}>
			<Grid2 lap={12} sx={12}>
				<TextField label="Nombre" fullWidth {...register("nombre")} />
			</Grid2>
			<Grid2 lap={12} sx={12}>
				<TextField
					label="Objetivo"
					fullWidth
					{...register("objetivo")}
					multiline
					minRows={2}
					maxRows={4}
				/>
			</Grid2>
			<Grid2 lap={12} sx={12}>
				<TextField
					fullWidth
					{...register("contribuciones")}
					label="Contribuciones"
					multiline
					minRows={2}
					maxRows={4}
				/>
			</Grid2>

			<Grid2 lap={6} sx={12}>
				<InputAutocompleteAreasId
					{...registerAutocompleted("departamento")}
					autoFetch={autoFetch}
				/>
			</Grid2>
			<Grid2 lap={6} sx={12}>
				<InputAutocompleteAreasId
					{...registerAutocompleted("reporta_a_departamento")}
					label="Departamento Reporta A"
					autoFetch={autoFetch}
				/>
			</Grid2>
			<Grid2 lap={6} sx={12}>
				<InputAutocompleteJobProfileId
					label="Jefe Inmediato"
					{...registerAutocompleted("reporta_a")}
					autoFetch={autoFetch}
				/>
			</Grid2>

			<Grid2 lap={6} sx={12}>
				<TextField fullWidth {...register("education")} label="Educación" />
			</Grid2>
			<Grid2 lap={6} sx={12}>
				<TextField
					fullWidth
					{...register("years_of_experience")}
					label="Años De Experiencia"
					type="number"
				/>
			</Grid2>
			<Grid2 justifyContent={"center"} lap={3} sx={12}>
				<InputCheckForm
					value={value.viajar}
					setValue={(datum) => setValue((old) => ({ ...old, viajar: datum }))}
				/>
			</Grid2>
		</Grid2>
	)
}

const InputCheckForm = ({ value, setValue }) => {
	return (
		<FormGroup
			sx={{
				display: "flex",
				flexDirection: "column",
				// alignItems: "center", // centra en horizontal
				justifyContent: "center", // centra en vertical
				height: "100%", // necesario para que tome todo el alto del Grid
			}}
		>
			<FormControlLabel
				control={
					<Checkbox
						checked={value}
						onChange={(event) => setValue(event.target.checked)}
					/>
				}
				label="¿Puede Viajar?"
			/>
		</FormGroup>
	)
}

const jobProfileValidate = (jobProfile) => {
	if (!jobProfile.nombre) {
		toast.error("El campo Nombre es obligatorio")
		return
	}
	if (!jobProfile.objetivo) {
		toast.error("El campo Objetivo es obligatorio")
		return
	}
	if (!jobProfile.contribuciones) {
		toast.error("El campo Contribuciones es obligatorio")
		return
	}
	if (!jobProfile.education) {
		toast.error("El campo Educación es obligatorio")
		return
	}
	if (!jobProfile.years_of_experience) {
		toast.error("El campo Años De Experiencia es obligatorio")
		return
	}

	return true
}

export const JobProfileFormDialog = ({ open, setOpen, profileData, refresh }) => {
	const profileId = profileData.id
	const [profile, setProfile] = useState(PROFILE_DEFAULT)
	useEffect(() => {
		setProfile(fillDefaults(profileData, PROFILE_DEFAULT))
	}, [profileData])

	const [disabled, setDisabled] = useState(false)
	const success = () => {
		setOpen(false)
		setProfile(PROFILE_DEFAULT)
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(jobProfilePut, { success, end })

	const handleSend = useCallback(() => {
		if (!jobProfileValidate(profile)) return
		setDisabled(true)
		fetch(profileId, profile)
	}, [fetch, profile, profileId])

	const handleClose = useCallback(() => {
		setOpen(false)
	}, [setOpen])

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: handleClose,
				disabled,
			},
			{
				label: "Actualizar",
				onClick: handleSend,
				disabled,
			},
		],
		[disabled, handleClose, handleSend]
	)

	return (
		<MasterDialog
			{...{
				open,
				setOpen,
				title: `Editar Perfil Puesto ${profile.nombre}`,
				buttons,
				maxWidth: "md",
				closeDialog: handleClose,
			}}
		>
			<JobProfileForm value={profile} setValue={setProfile} />
		</MasterDialog>
	)
}
